import React from "react";
import Hero from "../components/Hero";
import StartSection from "../components/StartSection";
import FeaturesChess from "../components/FeaturesChess";
import FeaturesGrid from "../components/FeaturesGrid";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import CoFounders from "../components/CoFounders";
import CtaFooter from "../components/CtaFooter";

export default function Home() {
  return (
    <>
      <Hero />
      <div className="bg-black">
        <StartSection />
        <FeaturesChess />
        <FeaturesGrid />
        <Stats />
        <Testimonials />
        <CoFounders />
        <CtaFooter />
      </div>
    </>
  );
}
